const cycle = (min, max) => (t) => {
    const maxExclusive = max + 1;
    const idx = (t - min) % (maxExclusive - min);
    return idx >= 0 ? idx + min : maxExclusive + idx;
};
export default cycle;
//# sourceMappingURL=bounded-cycle.js.map